import SolicitationsGrid from './SolicitationsGrid';

export default SolicitationsGrid;



// WEBPACK FOOTER //
// ./src/components/grids/SolicitationsGrid/index.jsx